/** Rules for names in employment administration (add/edit): letters, spaces, period (.), apostrophe (') and hyphen/dash (-) */
export const containsOnlyLatinLettersAndSpecialChars = (value: string): boolean => {
  return regex.test(value);
};

/*
  The following regex pattern makes sure the string only contains the allowed characters

  ^ asserts position at start of the string
    + matches between one and unlimited times

    \p{Script=Latin}  matches any characters in the Latin script
    .                 matches the character .
    \-                matches the character -
    \s                matches any whitespace character
    '                 matches the character '

  $ asserts position at the end of the string
  Global pattern flags
    u modifier: unicode. Enable all unicode features and interpret all unicode escape sequences as such

 */
const regex = /^[\p{Script=Latin}.\-\s']+$/u;
